// extracted by mini-css-extract-plugin
export default {"wrapper":"WuDynJLrObk7LhaEBo3T","heading":"D7HaXFWE0BKczh6psYL0","functionality":"EsAA7IDWezuIJC5cE0Zx","image":"oVEa9vjqfZLA_tVkOSiX"};